import { styled } from 'styled-components';
import { device } from '@/styles/helpers';

export const ScLoyaltyProgramPopup = styled.div`
  display: flex;
  width: 344px;
  padding: 16px;
  flex-direction: column;
  align-items: center;
  border-radius: 24px;
  background: #1c1c1e;

  & .general-info {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    margin-bottom: 8px;
  }

  & .paragraph-1 {
    color: ${({ theme }) => theme.whiteColor};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0;

    & span {
      color: ${({ theme }) => theme.whiteColor};
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: 0.14px;
    }
  }

  & .paragraph-2 {
    color: #8e8e93;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0;

    & span {
      color: ${({ theme }) => theme.whiteColor};
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 14px;
      letter-spacing: 0;
    }
  }

  & .link-view-perks {
    display: flex;
    align-items: center;
    gap: 2px;
    color: #25aad6;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.16px;
    text-transform: uppercase;
    margin-top: 16px;
  }

  & .message {
    color: ${({ theme }) => theme.whiteColor};
  }

  & .btn-arrow {
    display: none;
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    color: inherit;
    outline: none;
    margin-left: auto;
    transform: rotate(90deg);
    width: 19px;
    height: 19px;
    color: #8e8e93;

    &.active {
      transform: rotate(270deg);
      color: ${({ theme }) => theme.whiteColor};
    }
  }

  @media (${device.mobile}) {
    padding: 0;
    width: 100%;

    & .btn-arrow {
      display: block;
    }

    & .last-level {
      margin-bottom: 12px;
    }
  }
`;

export const ScLoyaltyProgramIcon = styled.div`
  position: relative;

  & img {
    position: relative;
    z-index: 2;
  }

  & .blur {
    position: absolute;
    width: 20px;
    height: 20px;
    filter: blur(22px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
`;
